import { Link } from "react-router-dom";

export default function MarketingFooter() {
  return (
    <footer className="bg-slate-900 text-white" data-testid="marketing-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <img src="/BrainyDoLogo.svg" alt="BrainyDo" className="h-14 w-auto" />
            </div>
            <p className="text-slate-400 text-sm">
              Your WhatsApp Task & Follow-up Engine
            </p>
          </div>

          {/* Product Links */}
          <div>
            <h4 className="font-semibold mb-4">Product</h4>
            <div className="space-y-2">
              <Link to="/features" className="block text-slate-400 hover:text-white text-sm transition">
                Features
              </Link>
              <Link to="/pricing" className="block text-slate-400 hover:text-white text-sm transition">
                Pricing
              </Link>
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-semibold mb-4">Company</h4>
            <div className="space-y-2">
              <Link to="/about" className="block text-slate-400 hover:text-white text-sm transition">
                About
              </Link>
              <Link to="/contact" className="block text-slate-400 hover:text-white text-sm transition">
                Contact
              </Link>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold mb-4">Legal</h4>
            <div className="space-y-2">
              <a href="#" className="block text-slate-400 hover:text-white text-sm transition">
                Privacy Policy
              </a>
              <a href="#" className="block text-slate-400 hover:text-white text-sm transition">
                Terms of Service
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-slate-700 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-slate-400 text-sm">
              © {new Date().getFullYear()} BrainyDo. All rights reserved.
            </p>
            <div className="flex flex-col md:flex-row items-center gap-3 text-sm text-slate-400">
              <span>Product of</span>
              <a
                href="https://webteampl.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-blue-300 transition font-semibold"
              >
                WebTeam Private Limited
              </a>
            </div>
            <p className="text-slate-400 text-sm">
              Made with ❤️ in India
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
